export default __webpack_public_path__ + "projectManIcon.png";